import Vue from "vue";
import get from "lodash/get";
import clone from "lodash/clone";

const getIndex = (items, entry, key) =>
  items.findIndex((item) => get(item, key) === get(entry, key));

const validArrayIndex = (index) => index === 0 || index > 0;

export const updateArrayEntry = (items, entry, key) => {
  // never mutate state
  const results = clone(items);
  const index = getIndex(results, entry, key);

  if (validArrayIndex(index)) {
    Vue.set(results, index, entry);
    return results;
  }

  return items;
};

export const deleteArrayEntry = (items, entry, key) => {
  const results = clone(items);
  const index = getIndex(results, entry, key);

  if (validArrayIndex(index)) {
    Vue.delete(results, index, entry);
    return results;
  }

  return results;
};

export const convertUTCDateToLocalDate = (date) => {
  try {
    date.setHours(date.getHours() - 3);
    var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    return newDate;
  } catch (error) {
    return date;
  }
};
